// extracted by mini-css-extract-plugin
export var container = "footer-module--container--c231e";
export var infoContainer = "footer-module--infoContainer--8e282";
export var leftCol = "footer-module--leftCol--e8ac6";
export var main = "footer-module--main--0bc16";
export var rightCol = "footer-module--rightCol--c5522";